import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from '../../../services/etiquetado.service';
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
    selector: 'app-mantenimientoEnvases-new-edit',
    templateUrl: './new-edit.component.html'
})
export class MantenimientoEnvasesNewEditComponent implements OnInit {

    private _envase;

    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();
    public registroEnUso = true;

    @Input() envaseId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _dataProvider: DataProvider,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _sessionContext: SessionContextService
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            des: ['', Validators.required],
            etiquetador: ['', Validators.required],
            kilos: ['', Validators.compose([
              Validators.required,
              Validators.min(0)
            ])],
            unidadMedida: ['', Validators.required]
        });

        if (this.envaseId) {
            this.getEnvase();
        } else {
            // Preselección de Kg para nuevo envase
            this.newEditForm.get('unidadMedida').patchValue(this.unidadesMedida[0]);
        }

    }

    public get etiquetadores() {
        return this._dataProvider.etiquetadores;
    }

    public get unidadesMedida() {
        let unidadesMedida = [
            {
                id: 1,
                des: 'Kilogramos'
            },
            // {
            //     id: 2,
            //     des: 'Tallos'
            // },
            // {
            //     id: 3,
            //     des: 'Libras'
            // },

        ];
        return unidadesMedida;
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public getEnvase() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.getEnvase(this.envaseId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this._envase = resp;
            this.registroEnUso = resp.registroEnUso;
            this.newEditForm.patchValue({
                des: resp.des,
                etiquetador: this.etiquetadores.find(x => x.id === resp.etiquetadorId),
                kilos: resp.kilos,
                unidadMedida: this.unidadesMedida.find(x => x.id === resp.unidadMedidaId),
            })
        }, (error) => {
            this.showApiError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.envaseId) {
            this._envase = {
                des: this.newEditForm.get('des').value,
                etiquetadorId: this.newEditForm.get('etiquetador').value.id,
                kilos: this.newEditForm.get('kilos').value,
                unidadMedidaId: this.newEditForm.get('unidadMedida').value.id
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.createEnvase(this._envase).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                  this.refresh.emit(true);
                  this.mensaje.emit('global.success.itemCreated');
                } else {
                  this.showError = true;
                  this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        } else if (this.newEditForm.valid && this.envaseId) {
            this._envase = {
                id: this.envaseId,
                des: this.newEditForm.get('des').value,
                etiquetadorId: this.newEditForm.get('etiquetador').value.id,
                kilos: this.newEditForm.get('kilos').value,
                unidadMedidaId: this.newEditForm.get('unidadMedida').value.id
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.updateEnvase(this._envase).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.refresh.emit(true);
                this.mensaje.emit('global.success.itemCreated');
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        }

    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }
}
